export const applicationMessages = {
    cloneAssessmentConfirm: 'Are you sure you want to clone this assessment?',
    submitAssessmentConfirm: 'Are you sure you want to submit the assessment?',
    closeCodingEditor: 'Do you want to submit this answer?',
    deleteAssessmentConfirm: 'Are you sure you want to delete the assessment?',
    deleteAssessmentModuleConfirm: 'Are you sure you want to delete all {moduleType} from the assessment?',
    brandingDeleteTemplateConfirm: 'Are you sure you want to delete {templatename}?',
    questionLangDeleteConfirm: 'Are you sure you want to delete this language version of the question?',
    questionDeleteConfirm: 'Are you sure you want to delete this question?',
    adminDeleteConfirm: 'Are you sure you want to delete this admin?',
    cancelSubscriptionConfirm: 'Are you sure you want to cancel the subscription?',
    confirmModuleCompleted: 'Are you sure you want to proceed? You selected {selectedQuestions} out of {totalQuestions} expected question(s).'
}

export const toasterMessages = {
    subscriptionNotActive: 'Subscription is not active. Please upgrade.',
    assessmentCloneSuccess: 'Assessment has been cloned successfully.',
    submitAssessmentModuleSuccess: 'Your answers for {module} have been submitted.',
    submitAssessmentSuccess: 'Assessment has been submitted successfully.',
    submitQuestionWarning: 'Please run your code before submitting.',
    candidateAssessmentTimeWarning: 'You have been left with {timeLeft} mins to submit the assessment',
    candidateAssessmentInfo: 'The assessment will be automatically submitted in case of exceeding the time limit.',
    candidatePasswordInfo: 'Password and confirm password should be the same.',
    candidateSaveAnswer: 'Your answers have been saved.',
    candidateResetLink: `Reset password link has been sent to your email.`,
    candidateNoAssessmentFound: `No assessments found.`,
    candidateNoActiveAssessmentFound: `You currently have no active assessments assigned.`,
    templateChangeNotAllowed: `Template message of an active assessment can't be edited. Instead, a new assessment can be created by cloning.`,
    templateNoLogoNoPhone: 'Please select a different template. This template requires an enterprise phone number and logo.',
    templateNoLogo: 'Please select a different template. This template requires an enterprise logo.',
    templateNoPhone: 'Please select a different template. This template requires an enterprise phone number.',
    assessmentSave: 'The assessment has been successfully saved.',
    assessmentMinQuestionWarning: 'Assessment should have min one question.',
    assessmentCreationSuccess: 'Assessment created successfully.',
    assessmentUpdateSuccess: 'Assessment has been updated successfully.',
    assessmentDeleteSuccess: 'Assessment has been deleted successfully.',
    assessmentSingleInviteSuccess: 'Invite sent successfully!',
    assessmentInviteSuccess: 'Invites sent successfully!',
    reInviteSuccess: 'Re-invitation sent successfully.',
    reInviteFailed: 'Failed to send re-invitation. Please try again.',
    assessmentStatusUpdated: 'Assessment status has been updated successfully.',
    assessmentEditWarning: `The questions of an active assessment can't be edited. Instead, a new assessment can be created by cloning.`,
    brandingDeleteTemplateWarning: 'Error removing the template. At least one template must exist.',
    brandingLogoWarning: 'Logo image dimensions should be greater than 200x200.',
    brandingDetailsUpdateSuccess: 'Company details have been updated successfully.',
    questionLangDeleteSuccess: "The answer for {deleteLangRef} has been removed.",
    questionAlreadySelected: 'This question already has been added to the assessment.',
    questionMCQDeleteSuccess: 'MCQ has been deleted from the library successfully.',
    questionMCQAdded: 'New MCQ has been added to the library successfully.',
    questionMCQUpdated: 'Multiple-choice question updated successfully.',
    questionOEQDeleteSuccess: 'Open ended question has been deleted from the library successfully.',
    questionOEQAdded: 'New Open ended question has been added to the library successfully.',
    questionOEQUpdated: 'Open-ended question updated successfully.',
    questionCQDeleteSuccess: 'Coding question has been deleted from the library successfully.',
    questionCQAdded: 'New coding question has been added to the library successfully.',
    questionCQUpdated: 'Coding question has been updated successfully.',
    profileUpdatedSuccess: 'Profile has been updated successfully.',
    inviteAdminSuccess: 'The invitation has been sent successfully.',
    deleteAdminSuccess: 'The admin has been deleted.',
    cancelSubscriptionSuccess: 'Subscription cancellation succeeded. Your account remains active until the current period ends.',
    paymentSuccess: 'The payment has been successful.',
    contactEmailSentSuccess: 'The email has been sent successfully.',
    contactEmailSentFailed: 'Something went wrong. Please try again!',
    submitAssessment: {
        ZeroTestCasePassed: '0 test cases passed. Do you want to submit the code?',
        totalTestCasePassed: `{runTestResult} test case(s) passed. Do you want to submit the code?`,
        submitConfirm: `Are you sure you want to submit the question?`,
    },
    snackbar: {
        questionAddedToAssessment: `The question has been added to the assessment!`,
        questionRemovedFromAssessment: `The question has been removed from assessment!`,
        brandingTemplateDeleted: `Template deleted successfully`,
        atLeastOneLangWarning: "At least one language must be selected!",
        canSolveWithOtherLang: `The question can also be solved using {lang}`
    },
    developerIsUserExists: 'Something went wrong please try again!',
    RegisterSuccess: 'The registration process is completed successfully. Please login into your account.',
    resetLinkSent: 'Reset password link has been sent to your email.',
    somethingWentWrong: 'Something went wrong please try again!',
    reGeneratedQuestion: 'Question successfully regenerated!',
    // Status-aware toasts for candidate actions
    candidateActions: {
        reinvite: {
            NEW: 'New invite link sent. Old link will be disabled when the new link is opened.',
            IN_PROGRESS: 'Existing link resent. The candidate can continue their attempt.',
            COMPLETED: 'New invite link sent for a fresh attempt. Completed submission preserved.',
            DEFAULT: 'Invite link sent.'
        },
        resetReinvite: {
            NEW: 'Progress cleared and new invite link sent. Old link disables when the new link is opened.',
            IN_PROGRESS: 'Answers and progress deleted. New invite link sent.',
            COMPLETED: 'Submitted answers deleted. New invite link sent for a fresh attempt.',
            DEFAULT: 'Previous answers cleared and new invite link sent.'
        }
    }
}

// Centralized confirmation copy for candidate actions
export const confirmMessages = {
    reinvite: {
        NEW: "Send a new invite link? The current link stays valid until the candidate opens the new link; after that, the old link is disabled.",
        IN_PROGRESS: "Resend the existing link so the candidate can continue their attempt. Current answers are preserved.",
        COMPLETED: "Send the invite link again?",
        DEFAULT: "Send the invite link again?"
    },
    resetReinvite: {
        NEW: "Clear any saved progress for this candidate and send a new invite link. The current link stays valid until the new link is opened; then the old link is disabled. This cannot be undone.",
        IN_PROGRESS: "Delete all current answers and progress, then send a new invite link. The old link will be invalidated. This cannot be undone.",
        COMPLETED: "Delete the candidate’s submitted answers and send a new invite link for a fresh attempt. This cannot be undone.",
        DEFAULT: "This will clear previous answers and send a new invite link. This cannot be undone."
    }
}